import Header from "../../Components/Header";
import SideBar from "../../Components/SideBar";
import { BallerzToken, BallerzRedirect } from "../../Client/Ballerz.js";
import { useGetRequest } from "../../Client/index.js";
import SkillCardGroup from "../../Components/SkillCardGroup";
import MobileDropdown from "../../Components/MobileDropdown";
import { useLocation } from "react-router-dom";
import MobileFooter from "../../Components/MobileFooter";

export default function Skillzone() {
  let ballerzToken = BallerzToken();

  const location = useLocation();
  const bookingReference = location.state?.bookingReference;

  if (!ballerzToken) {
    BallerzRedirect();
  }

  const { status, data } = useGetRequest(
    `skillzone/group/${bookingReference}`,
    {}
  );

  if (status === "fetched") {
    return (
      <div className="min-h-screen flex flex-col bg-[#070d27] text-white">
        <Header
          title={"skillzone"}
          group={true}
          bookingReference={bookingReference}
        />

        <div className="flex flex-1">
          <SideBar usernames={data?.users} />

          <main className="flex-1 p-4 sm:p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="block sm:hidden">
                <MobileDropdown />
              </div>

              {data.sessions?.length === 0 && (
                <a
                  href="https://ballerz.co.uk/book-now/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={require("../../Assets/Images/NoSkillzone.png")}
                    alt="No results"
                    draggable={false}
                    className="w-[95%] h-auto mx-auto"
                  />
                </a>
              )}

              {data?.sessions?.map((skill, index) => (
                <SkillCardGroup
                  backgroundImage={skill.ballerzImage}
                  gameImage={skill.ballerzIcon}
                  ballerzGameName={skill.ballerzGameName}
                  esaIsHitMiss={skill.esaIsHitMiss}
                  hit={skill.hit}
                  miss={skill.miss}
                  scoreDisplay={skill.scoreDisplay}
                  best={skill.best}
                  previous={skill.previous}
                  league={skill.league}
                />
              ))}
            </div>

            <div className="block sm:hidden">
              <MobileFooter />
            </div>
          </main>
        </div>
      </div>
    );
  }
}
